/**
 * Tiny event bus that decouples the imperative toast() API from the React
 * context. This file has NO imports from other Toast files, breaking the
 * circular dependency:  ToastContext → toast → ToastContext
 */

import type { ToastOptions, ToastType } from "./types.ts";

type AddFn = (type: ToastType, message: string, options?: ToastOptions) => string;
type DismissFn = (id?: string) => void;
type UpdateFn = (id: string, type: ToastType, message: string, options?: ToastOptions) => void;

let _add: AddFn | null = null;
let _dismiss: DismissFn | null = null;
let _update: UpdateFn | null = null;

export function registerHandlers(add: AddFn, dismiss: DismissFn, update: UpdateFn) {
  _add = add;
  _dismiss = dismiss;
  _update = update;
}

export function busAdd(type: ToastType, message: string, options?: ToastOptions): string {
  if (!_add) { console.warn("[Toast] ToastProvider not mounted."); return ""; }
  return _add(type, message, options);
}

export function busDismiss(id?: string) {
  if (_dismiss) _dismiss(id);
}

export function busUpdate(id: string, type: ToastType, message: string, options?: ToastOptions) {
  if (_update) _update(id, type, message, options);
}
